import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  AppDataService,
  StepsService,
  BaseSiteCoreAPIMapper,
  StepRequest,
  GlobalVariablesService,
  AvailableDocument,
  DocumentService,
  DocumentsResponse
} from '@tmhcc-ng-lib/data-service';
import { StepResponse } from '@tmhcc-ng-lib/data-service';
import { ActivatedRoute } from '@angular/router';
import { has } from 'libs/util/has-value';
import { Status } from '@tmhcc-ng-lib/models';
import { StepNevigationService } from '../nevigation/step-nevigation.service';

export class BasePendingSnapshotComponent {
  public policySnapshot: StepResponse;
  public documentsData: DocumentsResponse;
  public isDataAvailable = false;
  public siteCoreData;
  public tableDefinition;
  constructor(
    protected loaderService: LoaderService,
    protected appDataService: AppDataService,
    protected stepsService: StepsService,
    protected siteCoreAPIMapper: BaseSiteCoreAPIMapper,
    protected activatedRoute: ActivatedRoute,
    protected globalVariables: GlobalVariablesService,
    protected documentService: DocumentService,
    protected stepNevigationService: StepNevigationService
  ) {}

  callNgOnInit() {
    this.loaderService.show();
    this.appDataService.showSummary.next(true);
    //this.appDataService.stepsSitecoreContent.next();
    this.appDataService.summarySitecoreContent.next();

    this.appDataService.getStepsSitecoreData().subscribe(res => {
      if (res) {
        this.siteCoreData = res;
      }
      this.tableDefinition = this.siteCoreAPIMapper.fetchGridDataFromMappedSitecoreData(
        this.activatedRoute.snapshot.data['steps'],
        'Documents'
      );
    });
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.appDataService.fetchAndPublishPolicyDetails(payload);
    this.appDataService.getPolicyDetails().subscribe(res => {
      if (res) {
        this.policySnapshot = res;
        this.globalVariables.policyStatus =
          res.SummaryDetails.SummaryPendingItem.PolicyStatus;
        this.appDataService.stepsSitecoreContent.next();
        setTimeout(() => {
          this.loaderService.hide();
        }, 300);
      }
    });
    this.getDocumentDetails(payload);
  }

  getDocumentDetails(payload) {
    this.appDataService.fetchAndPublishDocumentsDetail(payload);
    this.appDataService.getDocumentsDetail().subscribe(res => {
      if (res) {
        this.documentsData = res;
        if (
          has(res.SummaryDetails, 'SummaryPendingItem.PolicyStatus') &&
          has(
            this.policySnapshot,
            'SummaryDetails.SummaryPendingItem.PolicyStatus'
          ) &&
          res.SummaryDetails.SummaryPendingItem.PolicyStatus !=
            this.policySnapshot?.SummaryDetails.SummaryPendingItem.PolicyStatus
        ) {
          let payload: StepRequest = {
            policyId: this.globalVariables.policyId,
            versionNum: this.globalVariables.policyVersionId
          };
          this.appDataService.fetchAndPublishPolicyDetails(payload);
        }
      }
    });
  }

  downloadPdfFile(doc: AvailableDocument) {
    this.loaderService.show();
    let endpoint = this.documentService.generateEndpoint(
      doc,
      this.globalVariables.policyId,
      this.globalVariables.policyVersionId
    );
    this.documentService.downloadPdfData(endpoint).subscribe(base64 => {
      this.documentService.downloadPdf(base64.Pdf, doc.Name);
      this.loaderService.hide();
    });
  }
  handleFileInput() {}
  fillOutForm() {}
}
